import { render, staticRenderFns } from "./Mails.create.vue?vue&type=template&id=42656001&"
import script from "./Mails.create.vue?vue&type=script&lang=js&"
export * from "./Mails.create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports